export default __webpack_public_path__ + "static/media/users-icon.ff23723f.svg";